export default "__VITE_ASSET__e4aae5ae__"